import { render, staticRenderFns } from "./SamplePlans.vue?vue&type=template&id=11cfe20c&"
import script from "./SamplePlans.vue?vue&type=script&lang=js&"
export * from "./SamplePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports